<template>
    <a v-if="location.Url" class="lp-location"
       :key="`location-${String(index)}`"
       :href="detailsUrl + location.Url">
        <location-pin :icon-url="location.PinIcon" :background-color="location.PinBackground" :border-color="location.PinBorder"></location-pin>
        <div>
            <h4>{{ location.DisplayName }}</h4>
            <address>
                {{ location.Street }}<br />
                {{ location.City }}, {{ location.State }} {{ location.Zip }}<br />
                <a :href="`tel:${location.Phone.replace(/[^0-9]/, '')}`">
                    {{
                        formatPhoneNumber(location.Phone)
                    }}
                </a>
            </address>
        </div>
    </a>
    <div v-else class="lp-location"
         :key="`location-${String(index)}`">
        <location-pin :icon-url="location.PinIcon"
                      :background-color="location.PinBackground"
                      :border-color="location.PinBorder" />
        <div>
            <h4>{{ location.DisplayName }}</h4>
            <address>
                {{ location.Street }}<br />
                {{ location.City }}, {{ location.State }} {{ location.Zip }}<br />
                <a :href="`tel:${location.Phone.replace(/[^0-9]/, '')}`">
                    {{
                        formatPhoneNumber(location.Phone)
                    }}
                </a>
            </address>
        </div>
    </div>
</template>
<script>
    import { formatPhoneNumber } from '../helpers/formatting';
    import LocationPin from "./LocationPin.vue";

    export default {
        components: { LocationPin },
        name: 'LocationListItem',
        props: {
            location: {
                type: Object,
                required: true
            },
            detailsUrl: {
                tye: String,
                required: true
            },
            index: {
                type: Number,
                requred: true
            }
        },
        setup(props) {
            return {
                formatPhoneNumber,
            }
        }
    }
</script>

<style lang="scss" scoped></style>